import { useMemo } from 'react';
export const useAlternateLinks = () => {
    const alternates = useMemo(() => {
        if (typeof window !== 'undefined') {
            const links = Array.from(document.head.querySelectorAll('link[rel="alternate"]'));
            const mapped = links.map((link) => {
                const { href, hreflang } = link;
                return {
                    [hreflang]: {
                        href,
                        hreflang,
                    },
                };
            });
            return Object.assign({}, ...mapped);
        }
        return {};
    }, []);
    return alternates;
};
